export default __webpack_public_path__ + "static/media/AhoraInvertirEsFacil.4e5cf90c.png";